// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18b87","toggleWrap":"styles_toggleWrap__V_cWz","content":"styles_content__GIPUY","selectAreaCode":"styles_selectAreaCode__q9NZo"};